<template>
	<div class="page-program-add xc-page xc-page-full">
		<div class="xc-page-main">
			<div class="xc-breadcrumb">
				<router-link :to="$config.adminPath + '/program'">节目管理</router-link>
				<a>添加节目</a>
			</div>
			<div class="xc-row xc-s-flex">
				<div class="xc-card">
					<div class="xc-card-header">
						<div class="xc-card-title">添加节目</div>
					</div>
					<div class="xc-card-content">
						<form name="form" class="xc-corm" ref="form">
							<div class="xc-info">
								<div class="xc-info-title">基本信息</div>
								<div class="xc-info-content">
									<div class="xc-form-inline">
										<xc-form-item 
											label="节目名称：" 
											required 
											:error="errors.first('programName')"
										>
											<input
												type="text"
												name="programName"
												class="xc-input"
												placeholder="请输入节目名称"
												data-vv-as="节目名称"
												v-validate="'required'"
												v-model="programInfo.programName"
											>
										</xc-form-item>
										<xc-form-item 
											label="品牌名称：" 
											required 
											:error="errors.first('brandName')"
										>
											<!-- <input
												type="text"
												name="brandName"
												class="xc-input"
												placeholder="请输入品牌名称"
												data-vv-as="品牌名称"
												v-validate="'required'"
												v-model="programInfo.brandName"
											> -->
											<!-- <select
												name="brandName"
												class="xc-select"
												data-vv-as="品牌名称"
												v-validate="'required'"
												v-model="programInfo.brandId"
											>
												<option value="">请选择</option>
												<option 
													:value="item.brandId" :key="index" v-for="(item, index) in brandList"
												>
													{{item.brandName}}
												</option>
											</select> -->

											<el-autocomplete
												value-key="brandName"
												class="inline-input"
												size='small'
												v-model="programInfo.brandName"
												:fetch-suggestions="querySearch"
												placeholder="请输入内容"
												@select="handleSelect"
											></el-autocomplete>
										</xc-form-item>
										<!-- <xc-form-item 
											label="终端类型：" 
											required 
											:error="errors.first('deviceType')"
										>
											<label class="xc-checkbox-wrap">
												<input
													type="checkbox"
													name="deviceType"
													data-vv-as="终端类型"
													v-validate="'required'"
													value="横屏"
													class="xc-checkbox"
													v-model="programInfo.deviceType"
												>
												<span class="xc-checkbox-label">横屏</span>
											</label>
											<label class="xc-checkbox-wrap">
												<input
													type="checkbox"
													name="deviceType"
													data-vv-as="终端类型"
													v-validate="'required'"
													value="竖屏"
													class="xc-checkbox"
													v-model="programInfo.deviceType"
												>
												<span class="xc-checkbox-label">竖屏</span>
											</label>
										</xc-form-item> -->
									</div>
									<div class="xc-form-inline">
										<xc-form-item 
											label="分辨率：" 
											required 
											:error="errors.first('deviceResolution')"
										>
											<label 
												class="xc-checkbox-wrap" 
												v-for="(item,index) in resolution" 
												:key="index"
											>
												<input
													type="checkbox"
													name="deviceResolution"
													data-vv-as="分辨率"
													v-validate="'required'"
													:value="item"
													class="xc-checkbox"
													v-model="programInfo.deviceResolution"
												>
												<span class="xc-checkbox-label">
													{{item}}
												</span>
											</label>
										</xc-form-item>
									</div>
								</div>
							</div>
							<div class="xc-info">
								<div class="xc-info-title">投放设置</div>
								<div class="xc-info-content">
									<div class="xc-form-inline">
										<xc-form-item 
											label="投放级别：" 
											required 
											:error="errors.first('putinLevel')"
										>
											<select
												name="putinLevel"
												class="xc-select"
												data-vv-as="投放级别"
												v-validate="'required'"
												v-model="programInfo.putinLevel"
											>
												<!-- <option value="1">普通计划</option>
												<option value="2">插播计划</option> -->
												<option 
													:value="item.value" 
													v-for="(item, index) in programLevel" 
													:key="index"
												>
													{{item.desc}}
												</option>
											</select>
										</xc-form-item>
									</div>
									<!-- <div class="xc-form-inline">
										<xc-form-item 
											label="投放限制：" 
											required 
											:error="errors.first('putinLimit')"
										>
											<select
												name="putinLimit"
												class="xc-select"
												data-vv-as="投放限制"
												v-model="dayType"
												@change="onTheLimit"
											>
												<option value="no-limit">不限</option>
												<option value="custom">自定义</option>
												<option 
													:value="item.value" 
													v-for="(item, index) in programLimit" 
													:key="index"
												>
													{{item.desc}}
												</option>
											</select>
										</xc-form-item>
									</div> -->
									<div class="xc-form-inline">
										<xc-form-item label="投放周期：" required>
											<div class="day-list">
												<div class="list" v-for="(item, index) in dayGroup" :key="index">
													<div 
														class="day-check-box" 
														:class="dayGroup[index].status == true ? 'dynamicCheckBox' : 'fDynamicCheckBox'"
														@click="dayGroup[index].status = !dayGroup[index].status"
													>
														<img src="../assets/gou.png">
													</div>
													<div class="day-content" v-if="index == 0">周一</div>
													<div class="day-content" v-if="index == 1">周二</div>
													<div class="day-content" v-if="index == 2">周三</div>
													<div class="day-content" v-if="index == 3">周四</div>
													<div class="day-content" v-if="index == 4">周五</div>
													<div class="day-content" v-if="index == 5">周六</div>
													<div class="day-content" v-if="index == 6">周日</div>
												</div>
											</div>
											<p class="hint" v-if="hintSign">默认周一到周日（可自定义选择投放周期）</p>
										</xc-form-item>
									</div>
									<div class="xc-form-inline">
										<xc-form-item 
											label="开始时间：" 
											required 
											:error="errors.first('putinStartTime')"
										>
											<input
												type="text"
												name="putinStartTime"
												class="xc-input putin-start-time"
												placeholder="请输入开始时间"
												data-vv-as="投放开始时间"
												v-validate="'required'"
												v-model="programInfo.putinStartTime"
											/>
										</xc-form-item>
									</div>
									<div class="xc-form-inline">
										<xc-form-item 
											label="结束时间：" 
											required 
											:error="errors.first('putinEndTime')"
										>
											<input
												type="text"
												name="putinEndTime"
												class="xc-input putin-end-time"
												placeholder="请输入投放结束时间"
												data-vv-as="投放结束时间"
												v-validate="'required'"
												v-model="programInfo.putinEndTime"
											/>
										</xc-form-item>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<div class="xc-page-footer">
			<div class="xc-btn-group">
				<button 
					type="button" 
					class="xc-btn xc-btn-default" 
					@click="cancle"
				>返回</button>
				<button 
					type="button" 
					class="xc-btn xc-btn-primary" 
					@click="nextStep"
				>下一步</button>
			</div>
		</div>
	</div>
</template>

<script>
import flatpickr from 'flatpickr';
import '@/libs/flatpickr';
import '@/libs/vee-validate';
import '@/utils/form-format';

import programApi from '../api/program';
import globalConfig from '../api/global-config';
import deviceApi from "../api/device";

export default {
	name: 'ProgramAdd',
	data() {
		return {
			// daySign: false,
			// dayType: 'no-limit',
			dayGroup: [{
				status: true,
				index: 0,
				text: '周一'
			}, {
				status: true,
				index: 1,
				text: '周二'
			}, {
				status: true,
				index: 2,
				text: '周三'
			}, {
				status: true,
				index: 3,
				text: '周四'
			}, {
				status: true,
				index: 4,
				text: '周五'
			}, {
				status: true,
				index: 5,
				text: '周六'
			}, {
				status: true,
				index: 6,
				text: '周日'
			}],
			hintSign: true,
			// 投放周期
			deliveryCycle: [],
			resolution: [],
			programLimit: [],
			programLevel: [],
			programInfo: {
				deviceResolution: ['1080x1920'],
				deviceType: ['横屏'],
				putinLimit: '',
				putinLevel: '',
				// putinStartTime: moment().add(5, 'minutes').format('YYYY-MM-DD HH:mm:ss'),
				putinStartTime: "",
				// putinEndTime:null,
				brandId: "",
			},
			// 品牌列表
            brandList:[],
		}
	},
	created() {
		this.initData();
	},
	methods: {
		// // 选择投放限制
		// onTheLimit() {
		// 	if(this.dayType == 'no-limit') {
		// 		this.daySign = false;
		// 	}else if(this.dayType == 'custom') {
		// 		this.daySign = true;
		// 	}
		// },
		// 带搜索的输入选择
		querySearch(queryString, cb) {
        var restaurants = this.brandList;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.brandName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
			handleSelect(item){
				console.log(this.programInfo.brandId)
				console.log(item)
				this.programInfo.brandId=item.brandId
			},
		initData() {
			if (this.$route.name == 'programEditor') {
				programApi.programDetail({
					programVersion: this.$route.params.programVersion
				}).then(v => {
					this.hintSign = false;

					for(let item of this.dayGroup) {
						if(v.data.putinLimit.indexOf(item.index) == -1) {
							item.status = false;
						}
					}
					
					v.data.deviceResolution = v.data.deviceResolution.split(',');
					// v.data.deviceType = v.data.deviceType.split(',');
					v.data.sourceInfo = v.data.sourceInfo || {};
					this.programInfo = v.data;
					var vue = this
					this.brandList.forEach(function(v){
						if(v.brandId==vue.programInfo.brandId){
							vue.programInfo.brandName=v.brandName
						}
					})
				})
			} else {
				if (this.$route.query.localStorage && localStorage.programInfo) {
					this.programInfo = JSON.parse(localStorage.programInfo);

					if (typeof this.programInfo.deviceResolution == 'string') {
						this.programInfo.deviceResolution = this.programInfo.deviceResolution.split(',');
					}
					// if (typeof this.programInfo.deviceType == 'string') {
					// 	this.programInfo.deviceType = this.programInfo.deviceType.split(',');
					// }
				}
			}

			globalConfig().then(v => {
				this.resolution = v.data.resolution;
			});

			// 获取品牌名称列表
			this.$http.get("/brand/listAllBrands").then(res => {
                this.brandList = res.data;
            })
		},
		cancle: function () {
			if(parent.layer){
				parent.layer.close(parent.layer.getFrameIndex(window.name));
			}else{
				this.$router.push(this.$config.adminPath + "/program");
			}
		},
		nextStep: function () {
			this.$validator.validateAll().then(validate => {
				if (validate) {
					if (this.programInfo.putinStartTime > this.programInfo.putinEndTime) {
						this.$message.error("投放开始时间不能大于结束时间")
						return;
					}
					if (new Date(this.programInfo.putinStartTime) <= new Date()) {
						this.$message.error("投放开始时间必须大于当前时间")
						return;
					}

					const data = this.$formFormat(this.$refs.form);

					// 二次验证，为了解决详情数据和全局配置有差异
					if (!data.deviceResolution) {
						return this.$message.error('请选择分辨率');
					}

					programApi.checkName({
						programName: this.programInfo.programName,
						programVersion: this.programInfo.programVersion ? this.programInfo.programVersion : '',
					}).then(() => {
						data.programVersion = this.programInfo.programVersion;
						data.sourceJson = this.programInfo.sourceJson || {};

						// data.putinLimitName = putinLimit.options[putinLimit.selectedIndex].text;
						// data.putinLevelName = putinLevel.options[putinLevel.selectedIndex].text;
						data.putinLimit = [];
						for(let day in this.dayGroup) {
							if(this.dayGroup[day].status) {
								data.putinLimit = [ ...data.putinLimit, this.dayGroup[day].index ];
							}
						}
						console.log(data.putinLimit);

						data.putinLevelName = this.programInfo.putinLevel;
						data.addUserName = this.programInfo.addUserName;
						data.addTime = this.programInfo.addTime;
						data.updateTime = this.programInfo.updateTime;
						data.brandId = this.programInfo.brandId;
						localStorage.programInfo = JSON.stringify(data);

						// 调整对应分辨率编辑
						this.$router.push(this.$config.adminPath + '/program/add/editor');
					})
				} else {
					let error = this.errors.items[0].msg;
					this.$message.error(error);
				}
			})
		}
	},
	mounted() {
		flatpickr('.putin-start-time', {
			enableTime: true, enableSeconds: true,
			minDate: new Date(),
			time_24hr:true,
		});

		flatpickr('.putin-end-time', {
			enableTime: true, enableSeconds: true,
			time_24hr:true,
		});
		// 获取全局配置
		deviceApi.getGlobalconfig().then(v => {
			this.programLevel = v.data.programLevel;
			this.programLimit = v.data.programLimit;
			this.programInfo.putinLevel = v.data.programLevel[0].value;
			this.programInfo.putinLimit = v.data.programLimit[0].value;
		});
	}
}
</script>

<style lang="scss">
.page-program-add {
	.xc-form-item-label {
		min-width: 80px;
	}
}
.day-list {
	display: flex;
	height: 30px;
	line-height: 30px;
	.list {
		display: flex;
		.day-check-box {
			width: 16px;
			height: 16px;
			border: 1px solid #d7d7d7;
			border-radius: 4px;
			margin: 7px 10px 7px 0px;
		}
		.dynamicCheckBox {
			border: 1px solid #4a80f7;
			background-color: #4a80f7;
			img {
				display: block;
				width: 14px;
				height: 14px;
				border-radius: 4px;
			}
		}
		.fDynamicCheckBox img {
			display: block;
		}
		.day-content {
			margin-right: 20px;
		}
	}
}
.hint {
	height: 20px;
	line-height: 20px;
	font-size: 12px;
	color: red;
}
</style>
